import {
    UPDATE_ZENDESK
} from '../types/notificationTypes';

export const updateZendesk = (data) => ({
    type: UPDATE_ZENDESK,
    payload: data,
});

